var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContact = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6D68B4BA-121F-46A2-AD2B-824D851E736D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup-set-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown",
    transform: "translate(-1149.000000, -140.000000)",
    fill: "#9B9B9B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(1119.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(30.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6111111,35.3611111 C21.875,35.3611111 20.2083333,35.0833333 18.6527778,34.5694444 C18.1666667,34.4166667 17.625,34.5277778 17.2361111,34.9027778 L14.1805556,37.9583333 C10.25,35.9583333 7.02777778,32.75 5.02777778,28.8194444 L8.08333333,25.75 C8.47222222,25.375 8.58333333,24.8333333 8.43055556,24.3472222 C7.91666667,22.7916667 7.63888889,21.125 7.63888889,19.3888889 C7.63888889,18.625 7.01388889,18 6.25,18 L1.38888889,18 C0.625,18 0,18.625 0,19.3888889 C0,32.4305556 10.5694444,43 23.6111111,43 C24.375,43 25,42.375 25,41.6111111 L25,36.75 C25,35.9861111 24.375,35.3611111 23.6111111,35.3611111 Z M12.5,18 L12.5,31.8888889 L16.6666667,27.7222222 L25,27.7222222 L25,18 L12.5,18 Z",
    id: "Shape-Copy-2"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContact);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contact.6f59e8ba27bf663b2666633be6362793.svg";